import React from 'react';

import { MenuItem } from './models';

export interface NavItemProps {
  item: MenuItem;
  handleItemClick: (action: string, value: string, configurationName: string) => void;
}

export const NavItem: React.FC<NavItemProps> = ({ item, handleItemClick }: NavItemProps): React.ReactElement => {
  if (item.action) {
    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <li
        className="nav-item"
        onClick={
          item.action
            ? () => handleItemClick(item.action as string, item.value || '', item.configurationName || '')
            : undefined
        }
        onKeyDown={
          item.action
            ? () => handleItemClick(item.action as string, item.value || '', item.configurationName || '')
            : undefined
        }
      >
        <span className="nav-link">{item.title}</span>
      </li>
    );
  }
  return (
    <li className="nav-item">
      <a className="nav-link" href={item.path || '/'}>
        {item.title}
      </a>
    </li>
  );
};
